export enum CustomerType {
  Company = 'company',
  Individual = 'individual',
}
